//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SubscribeToggle',
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      imageBaseUrl: 'https://static.moele.me/img/channels2022/subscription/subscription-catalog.png?auto=format&w=743',
      showSubscribeItems: true,
    };
  },
};
